<template>
  <el-dialog
    title="优惠券推广"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    width="440px"
    @close="emitClose"
  >
    <div class="bcg-container">
      <div class="main">
        <div
          class="top-div"
          ref="imageWrapper"
        >
          <span id="span1">{{this.content.name}}</span>
          <span
            id="span2"
            v-if="this.content.discount_amount"
          >￥{{this.content.discount_amount}}优惠券</span>
          <span
            id="span2"
            v-if="this.content.discount_rate"
          >{{this.content.discount_rate}}折优惠券</span>
          <span id="span3">{{this.content.description}}</span>
          <span id="span4">{{this.content.min_cost==null?'无使用门槛':`满${this.content.min_cost}元可用`}}</span>
        </div>
        <div class="bottom-div">
          <span id="span5">有效期：{{ $moment(this.content.start_time).format("YYYY.MM.DD") }} -
            {{ $moment(this.content.end_time).format("YYYY.MM.DD") }}</span>
          <div
            class="qrcode-img"
            id="qrcode"
            ref="qrcode"
          ></div>
          <span>长按识别二维码领取</span>
        </div>
      </div>
    </div>
    <div class="down-div">
      <el-link
        type="primary"
        :underline="false"
        @click="draw"
      >下载图片</el-link>
      <el-link
        type="primary"
        :underline="false"
        @click="downloadQrcode"
      >下载二维码</el-link>
    </div>
    <!--    <div style="margin-top: 15px;">
      <el-autocomplete
        class="inline-input"
        v-model="admin_id"
        :fetch-suggestions="querySearch"
        placeholder="请选择管理员"
        :trigger-on-focus="false"
        @select="handleSelect"
        clearable
        style="width: 100%;"
      >
      </el-autocomplete>
    </div> -->
    <div style="margin-top: 15px;">
      <el-input
        placeholder="请输入内容"
        v-model="web_url"
        class="input-with-select"
        readonly
      >
        <el-button
          slot="append"
          type="primary"
          @click="copyUrl"
        >复制链接</el-button>
      </el-input>
    </div>

    <div class="content_container">
      <vue-canvas-poster
        :painting="painting"
        @success="success"
        @fail="fail"
      ></vue-canvas-poster>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2"
export default {
  components: {

  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      web_url: "",
      qrcode_url: null,
      imgUrl: "",//下载图片
      w: 320,
      h: 185,
      info: {},
      posterImg: '',//生成的海报
      painting: {},
      admin_id: "",
    };
  },
  mounted() {

  },
  activated() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
    },
    content(val) {
      this.$nextTick(() => {
        let url = `https://h5.kaoyanbox.com/activity/coupon/${this.content.id}`
        this.drawPic(url)
      })
    },
  },
  methods: {
    emitClose() {
      document.querySelector("#qrcode").innerHTML = "";
      this.$emit("close");
    },
    qrcode(url) {
      let qrcode = new QRCode("qrcode", {
        width: 100, // 二维码宽度，单位像素
        height: 100, // 二维码高度，单位像素
        /*  text: `https://h5.kaoyanbox.com/activity/coupon/${this.content.id}`, // 生成二维码的链接 */
        text: url,
      }); 
    },
    downloadQrcode() {
      let img = document.querySelectorAll('img')[1].currentSrc
      var a = document.createElement('a')
      a.download = 'qrcode'
      // 设置图片地址
      a.href = img;
      a.click();
    },
    copyUrl() {
      const input = document.createElement("textarea");
      input.setAttribute("id", "__mouse__position_input");
      input.value = this.web_url
      this.$copyText(input.value).then((e) => {
        this.$notify.success({
          title: "提示",
          message: "复制成功",
          type: "success",
        });
      });
    },
    draw() {
      var a = document.createElement('a')
      a.download = 'poster'
      // 设置图片地址
      a.href = this.posterImg;
      a.click();
    },
    success(src) {
      this.posterImg = src
    },
    fail(err) {
      alert(err)
    },
    querySearch(queryString, cb) {
      var restaurants = this.$store.state.adminList.map((v) => {
        return {
          value: v.nickname,
          id: v.id,
          code: v.invitecode
        }
      });
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      document.querySelector("#qrcode").innerHTML = "";
      let url = `https://h5.kaoyanbox.com/activity/coupon/${this.content.id}?ic=${item.code}`
      this.drawPic(url)
    },
    drawPic(url) {
      this.web_url = url
      this.qrcode(url);
      setTimeout(() => {
        this.painting = {
          width: '400px',
          height: '538px',
          background: require('../../../assets/img/coupon_bcg.png'),
          views: [{
            type: 'text',
            text: document.querySelector('#span1').innerHTML || '',
            css: {
              width: '280px',
              textAlign: 'center',
              fontSize: "18px",
              color: "#fff",
              fontWeight: '800',
              top: '128px',
              left: '64px',
            },
          },
          {
            type: 'text',
            text: document.querySelector('#span2') ? document.querySelector('#span2').innerHTML : '',
            css: {
              width: '280px',
              textAlign: 'center',
              fontSize: "36px",
              color: "#fff",
              fontWeight: '800',
              top: '161px',
              textAlign: 'center',
              left: '64px',
            },
          },
          {
            type: 'text',
            text: document.querySelector('#span3').innerHTML || '',
            css: {
              width: '280px',
              textAlign: 'center',
              fontSize: "14px",
              color: "#fff",
              fontWeight: '800',
              top: '225px',
              textAlign: 'center',
              left: '64px',
            },
          },
          {
            type: 'text',
            text: document.querySelector('#span4').innerHTML || '',
            css: {
              width: '280px',
              textAlign: 'center',
              fontSize: "12px",
              color: "#fff",
              fontWeight: '800',
              top: '256px',
              textAlign: 'center',
              left: '64px',
            },
          },
          {
            type: 'text',
            text: document.querySelector('#span5').innerHTML || '',
            css: {
              width: '280px',
              textAlign: 'center',
              fontSize: "12px",
              color: "#CCCCCC",
              top: '313px',
              textAlign: 'center',
              left: '64px',
            },
          },
          {
            type: 'image',
            url: document.querySelectorAll('img')[1].currentSrc,
            css: {
              left: '154px',
              width: '100px',
              height: '100px',
              top: '338px'
            }
          },
          {
            type: 'text',
            text: '长按识别二维码领取',
            css: {
              width: '280px',
              textAlign: 'center',
              fontSize: "12px",
              color: "#CCCCCC",
              top: '447px',
              textAlign: 'center',
              left: '64px',
            },
          },],
        }
      }, 800);
    }
  },
};
</script>

<style lang="less" scoped>
.bcg-container {
  width: 400px;
  height: 538px;
  background-image: url("https://upload.kaoyanbox.net/c2c522d7c3d9153e89fcef213b61c6e8.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 100px;
}
.main {
  margin: 0 auto;
  width: 344px;
  height: 394px;
  background-image: url("../../../assets/img/CouponExtension_bcg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 32px;
}
.top-div {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    display: block;
    font-family: PingFang SC;
    color: #ffffff;
    margin-bottom: 8px;
    &:nth-child(1) {
      font-size: 18px;
      font-weight: 800;
    }
    &:nth-child(2) {
      font-size: 40px;
      font-weight: 800;
      margin-bottom: 12px;
    }
    &:nth-child(3) {
      font-size: 14px;
      margin-bottom: 12px;
    }
    &:nth-child(4) {
      padding: 0px 32px;
      height: 24px;
      border: solid 1px #ffffff;
      font-size: 12px;
      border-radius: 4px;
      text-align: center;
      line-height: 22px;
    }
  }
}
.bottom-div {
  left: 50%;
  bottom: 140px;
  transform: translate(-50%, 0);
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    display: block;
    margin-bottom: 24px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #8d8d8d;
    opacity: 1;
  }
  .qrcode-img {
    width: 100px;
    height: 100px;
    margin-bottom: 12px;
  }
}
.down-div {
  margin-top: 16px;
  .el-link {
    font-size: 12px;
    margin: 0px 8px;
  }
}
</style>